<template lang="pug">
div
  .landing2(:class="{'cny' : cnyMode}")
    #xmas-rain1
    #xmas-rain2
    #cny-rain1
    #cny-rain2
    header.header
      .container.d-flex.justify-content-between.align-items-center
        .logo
          img.img-fluid(v-if="cnyMode" :src="logoCNYPath")
          img.img-fluid(v-else-if="xmasMode" :src="logoXMASPath")
          img.img-fluid(v-else :src="logoPath")
        .right-wrapper
          .d-flex.align-items-center.mr-2
            .btn-switch-device(v-if="!whiteLabel" @click="switchToDesktop")
              //- i.far.fa-mobile-android-alt.switch-device-mobile
              i.fas.fa-desktop-alt.switch-device-desktop
            .line
            .lang-wrap
              .lang-select2
                .btn-select
                  li
                    img(:src="'/images/lang/' + language + '.svg?v=12'")
                .lang-dropdown-wrap
                  ul#lang-dropdown-list
                    li(v-for="item in languageList" @click="setLanguage(item)")
                      img(:src="'/images/lang/' + item + '.svg?v=12'")
                      span {{ $t("language." + item) }}
    section.slider-wrap
      .container
        .swiper.lp-banner
          .swiper-wrapper
            //- .swiper-slide
            //-   .banner-text
            //-     h1 European Football Glory Awaits! 
            //-     p
            //-       | With a comprehensive selection of markets for EURO 2024 and all live matches to bet on, the adrenaline rush never ends.
            //-   img.banner-desktop(src='img2/landing2/banner/banner-euro24.png')
            //-   img.banner-mobile(src='img2/landing2/banner/banner-euro24-m.png')
            template(v-if="cnyMode")
              .swiper-slide
                .banner-text
                  h1 Joyful Chinese New Year To welcome great fortune!
                  p
                    | With festive offers, thrilling football action, and endless prosperity, celebrate Chinese New Year in style!
                img.banner-desktop(src='img2/landing2/banner/banner-cny25.png')
                img.banner-mobile(src='img2/landing2/banner/banner-cny25-m.png')
            template(v-if="xmasMode")
              .swiper-slide
                .banner-text
                  h1 Exciting holidays to get big wons!!!
                  p
                    | With festive offers, exciting football action, and endless wins, celebrate Christmas and New Year in style!
                img.banner-desktop(src='img2/landing2/banner/banner-xmas.png')
                img.banner-mobile(src='img2/landing2/banner/banner-xmas-m.png')            
            .swiper-slide
              .banner-text
                h1 Sports Betting
                p
                  | With a comprehensive selection of over 90 sports and thousands of live matches to bet on, the adrenalin rush never ends.
              img.banner-desktop(src='img2/landing2/banner/banner-sport.png')
              img.banner-mobile(src='img2/landing2/banner/banner-sport-m.png')
            .swiper-slide
              .banner-text
                h1 Live Casino
                p
                  | Rake in winnings, all while enjoying a rich and immersive casino gaming experience at any of our luxurious suites.
              img.banner-desktop(src='img2/landing2/banner/banner-casino.png')
              img.banner-mobile(src='img2/landing2/banner/banner-casino-m.png')
            .swiper-slide
              .banner-text
                h1 Slot Games
                p
                  | An extensive selection of games, as far as the eye can see. Get a firsthand taste of it now.
              img.banner-desktop(src='img2/landing2/banner/banner-slot.png')
              img.banner-mobile(src='img2/landing2/banner/banner-slot-m.png')
            .swiper-slide
              .banner-text
                h1 V-Games
                p
                  | Collect your favorite characters, throw down in competitive combat, enter the battlefield and feel the fight!
              img.banner-desktop(src='img2/landing2/banner/banner-efight.png')
              img.banner-mobile(src='img2/landing2/banner/banner-efight-m.png')
            .swiper-slide
              .banner-text
                h1 Tournament
                p
                  | Get ready for the ultimate display for skills, strategy, and passion as teams from all over the city battle it out in the annual football tournament.
              img.banner-desktop(src='img2/landing2/banner/banner-tournament.png')
              img.banner-mobile(src='img2/landing2/banner/banner-tournament-m.png')
            //- template(v-if="cnyMode")
            //-   .swiper-slide
            //-     .banner-text
            //-       h1 Lunar New Year
            //-       p
            //-         | Sending wishes of health, wealth,
            //-         br
            //-         | and wisdom in the lunar new year.
            //-     img.banner-desktop(src='img2/landing2/banner/banner-cny.png')
            //-     img.banner-mobile(src='img2/landing2/banner/banner-cny-m.png')
          .swiper-button-next
          .swiper-button-prev
          .swiper-pagination
    //- section.eurocup
    //-   .container.eurocup-timer
    //-     //- .eurocup-timer-wrapper.flex-grow-1
    //-     //-   .counter-wrapper.d-flex.justify-content-center
    //-     //-     #timer
    //-     .eurocup-timer-wrapper-finished.flex-grow-1
    //-       .finish-text-wrapper
    //-         h1
    //-           | Celebrate EURO CUP
    //-           span With Wbet!
    //-         h4 Join US NOW!
    //-     .timer-logo
    //-       img.desktop(src='img2/landing2/euro24-logo.png')
    //-       img.mobile(src='img2/landing2/euro24-logo-m.png')
    //- section.event-slider-wrap
    //-   .container
    //-     iframe.event-banner-iframe(src='event-banner/index.html' allowtransparency='true')
    //-     img.img-fluid(src='img2/landing2/transparent-slider-height.png')
    section.widget-wrap
      .container
        .mobile-login2
          .login-header {{ $t("ui.login") }}
          .login-field-wrapper
            .login-field
              .input-group
                .input-group-prepend
                  .input-group-text
                    i.far.fa-user
                input#username.form-control(v-model="username" type="text" :placeholder="$t('ui.account_id')" autofocus autocomplete="off" maxlength="20")
            .login-field
              .input-group
                .input-group-prepend
                  .input-group-text
                    i.far.fa-unlock-alt
                input#password.form-control(v-model="password" type="password" :placeholder="$t('ui.password')" autocomplete="off" maxlength="20" @keyup.enter="login")
          .invalid-feedback(v-if="feedback.password" style="display:block") {{ feedback.password }}
          .invalid-feedback(v-if="feedback.username" style="display:block") {{ feedback.username }}
          .invalid-feedback(v-if="result" style="display:block") {{ $t("error." + result) }}
          //- button.login-btn.flex-grow-1 Login
          SpinButton(:text="$t('ui.login')" :loading="feedback.loading" css="login-btn flex-grow-1" @click="login")
      .container
        .widget-content-wrapper
          .left
            .widget-box
              .widget-box-header {{ $t('ui.highlight') }}
              .widget-content
                iframe.hlighlight-iframe(:src="'https://wbetwidget.com/highlight?theme=6&lang=' + language", allowtransparency="true")
          .right
            .widget-box
              .widget-box-header {{ $t('ui.upcoming') }}
              .widget-content
                iframe.hotmatch-iframe(:src="'https://wbetwidget.com/upcomingmatch?theme=6&lang=' + language", allowtransparency="true")
            .widget-box.mt-4
              .widget-box-header {{ $t('ui.live_streaming') }}
              .widget-content
                iframe.livestream-iframe(:src="'https://wbetwidget.com/livestream?theme=6&lang=' + language", allowtransparency="true")
    footer.footer
      .container.footer-wrapper
        .tnc
          .d-flex.align-items-center
            h4
              img(src="/img2/landing2/18plus.png")
              | Underage Gambling
          .d-flex
            p
              | Gambling is illegal for kids under the age of 18. Every state prohibits gambling by minors. WBET will carry out age verification randomly and winnings will be forfeited if the gambler is below 18 years old.© 2004-2024 WBET. WBET is An Internationally Registered Trademark (Licensed Sports Bookmaker). All Rights Reserved.
        .row.pt-4.pb-4
          .col-8.license
            h4 License
            .d-flex.align-items-center.license-logo
              .image-wrap2
                img(src="/img2/landing2/license/01.png")
              .image-wrap2
                img(src="/img2/landing2/license/02.png")
              .image-wrap2
                img(src="/img2/landing2/license/03.png")
              .image-wrap2
                img(src="/img2/landing2/license/04.png")
              .image-wrap2
                img(src="/img2/landing2/license/05.png")
              .image-wrap2
                img(src="/img2/landing2/license/06.png")
              .image-wrap2
                img(src="/img2/landing2/license/07.png")
              .image-wrap2
                img(src="/img2/landing2/license/08.png")
          .col-4
            h4 Suggest Browser
            .d-flex.align-items-center.browser-logo
              .image-wrap2
                img(src="/img2/landing2/browser/chrome.png")
              .image-wrap2
                img(src="/img2/landing2/browser/edge.png")
              .image-wrap2
                img(src="/img2/landing2/browser/firefox.png")
              .image-wrap2
                img(src="/img2/landing2/browser/safari.png")
      .copyright
        .container © Copyright 2024 WBET Sportsbook

</template>

<script>
import config from "@/config"
import { required } from "vuelidate/lib/validators"
import errors from "@/errors"
import SpinButton from "@/components/ui/SpinButton"
import { EventBus } from "@/library/_event-bus.js"

function specialfx() {
  var cny = 'cny-rain'
  var xmas = 'xmas-rain'

  var css = config.cnyMode ? cny : config.xmasMode ? xmas : ''

  function animm(elm) {
    TweenMax.to(elm, R(6, 15), { y: h + 100, ease: Linear.easeNone, repeat: -1, delay: -5 });
    TweenMax.to(elm, R(2, 8), { x: "+=100", rotationZ: R(0, 180), repeat: -1, yoyo: true, ease: Sine.easeInOut });
    TweenMax.to(elm, R(2, 8), { rotationX: R(0, 360), rotationY: R(0, 360), repeat: -1, yoyo: true, ease: Sine.easeInOut, delay: -5 });
  }

  function R(min, max) {
    return min + Math.random() * (max - min);
  }

  TweenLite.set("#" + css + "1",{perspective:600})
  TweenLite.set("." + css + "1 img",{xPercent:"-30%",yPercent:"-30%"})

  var total = 50;
  var warp = document.getElementById(css + "1"),	w = window.innerWidth , h = window.innerHeight;

  for (var i=0; i<total; i++) {
    var Div = document.createElement('div');
    TweenLite.set(Div,{attr:{class: css + "1"},x:R(0,w),y:R(-200,-150),z:R(-200,200)});
    warp.appendChild(Div);
    animm(Div);
  }

  TweenLite.set("#" + css + "2",{perspective:600})
  TweenLite.set("." + css + "2 img",{xPercent:"-50%",yPercent:"-50%"})

  var total = 30;
  var warp = document.getElementById(css + "2"),	w = window.innerWidth , h = window.innerHeight;

  for (var i=0; i<total; i++) {
    var Div = document.createElement('div');
    TweenLite.set(Div,{attr:{class:css + "2"},x:R(0,w),y:R(-200,-150),z:R(-200,200)});
    warp.appendChild(Div);
    animm(Div);
  }

  // TweenLite.set("#cny-rain3",{perspective:600})
  // TweenLite.set(".cny-rain3 img",{xPercent:"-50%",yPercent:"-50%"})

  // var total = 30;
  // var warp = document.getElementById("cny-rain3"),	w = window.innerWidth , h = window.innerHeight;

  // for (var i=0; i<total; i++) {
  //   var Div = document.createElement('div');
  //   TweenLite.set(Div,{attr:{class:'cny-rain3'},x:R(0,w),y:R(-200,-150),z:R(-200,200)});
  //   warp.appendChild(Div);
  //   animm(Div);
  // }
}

export default {
  components: {
    SpinButton
  },
  data() {
    return {
      languageList: ["en", "cn", "vi", "th", "id", "kr", "jp", "tw"],
      username: "",
      password: "",
      feedback: {
        username: "",
        password: "",
        loading: false,
        timeout: null
      },
      result: ""
    };
  },
  computed: {
    logoPath() {
      return config.logoPath;
    },
    cnyMode() {
      return config.cnyMode;
    },
    xmasMode() {
      return config.xmasMode;
    },
    logoCNYPath() {
      return config.logoCNYPath;
    },
    logoXMASPath() {
      return config.logoXMASPath;
    },
    language() {
      return this.$store.getters.language;
    },
    brand() {
      return config.brand;
    },
    desktopUrl() {
      let domain = window.location.hostname
      return "https://" + domain.replace("m.", "") + "?view=desktop"
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    esports2() {
      return config.esports2 == "1";
    }
  },
  watch: {
    result(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.result = "";
        }, 10000);
      }
    }
  },
  validations: {
    username: {
      required
    },
    password: {
      required
    }
  },
  destroyed() {
    // clearInterval(this.countdown);
  },
  mounted() {
    $(".btn-select").click(function() {
      $(".lang-dropdown-wrap").toggle();
    })

    var swiper = new Swiper(".lp-banner", {
			speed: 400,
			loop: true,
			autoplay: true,
			draggable: true,

			navigation: {
				nextEl: ".lp-banner .swiper-button-next",
				prevEl: ".lp-banner .swiper-button-prev",
			},
			pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
		});

    this.$nextTick(() => {
      // this.countdown = setInterval(() => {
      //   var countDownDate = new Date("Jun 15, 2024 02:59:59").getTime();
      //   var now = new Date().getTime();

      //   var distance = countDownDate - now;
      //   var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      //   var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      //   var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      //   var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      //   document.getElementById("timer").innerHTML =
      //     '<div>' + days + '<span>days</span></div>' +
      //     '<div>' + hours + '<span>hours</span></div>' +
      //     '<div>' + minutes + '<span>minutes</span></div>' +
      //     '<div>' + seconds + '<span>seconds</span></div>' ;

      //   if (distance < 0) {
      //     clearInterval(this.countdown);
      //     $(".eurocup").addClass('d-none');
      //   }
      // }, 1000)

      if (this.brand == "WBET" && this.cnyMode) {
        specialfx();
      }

      if (this.brand == "WBET" && this.xmasMode) {
        specialfx();
      }
      // $(".carousel").carousel({
      //   interval: 5000
      // });
    });
  },
  methods: {
    switchToDesktop() {
      var url = this.desktopUrl;
      window.location = url;
    },
    setLanguage(lang) {
      this.$store.dispatch("layout/setLanguage", lang);
      $(".lang-dropdown-wrap").toggle();
    },
    reset() {
      this.feedback.username = "";
      this.feedback.password = "";
    },
    login() {
      // must invoke touch to validate the errors
      this.$v.$touch();
      clearTimeout(this.feedback.timeout);
      if (!this.$v.$invalid) {
        this.feedback.loading = true;
        this.reset();
        this.$store.dispatch("layout/reset");
        this.$store.dispatch("user/doLogin", { username: this.username, password: this.password }).then(
          res => {
            this.feedback.loading = false;
            if (res.success) {
              this.feedback.loading = true;
              this.$store.dispatch("user/getBalance").then(
                res => {
                  this.feedback.loading = false;
                  if (res.success) {
                    // $("#login-modal").modal("hide");
                    this.$store.dispatch("layout/setRadarId", null);
                    // this.$store.dispatch("layout/setSingleBetting", {property: "quickBet", value: false});
                    EventBus.$emit("INVALIDATE");
                    setTimeout(() => {
                      var isMMO = this.$store.getters.mmoMode;
                      if(["localhost","gsportm.joyful88.com"].includes(window.location.hostname)) {
                        this.$router.push("/lobby");
                      } else {
                        if(isMMO) {
                          let domain = window.location.hostname
                          let accountID = this.$store.getters.accountId
                          let sessionToken = this.$store.getters.sessionToken
                          window.location.href = "https://" + domain.replace("m.", "") + "?&u=" + accountID + "&st=" + sessionToken
                        } else {
                          this.$router.push("/lobby");
                        }
                      }
                    }, 500);
                  } else {
                    this.result = res.status;
                    // if (this.$helpers.handleFeedback(res.status)) {
                    // }
                  }
                },
                err => {
                  this.feedback.loading = false;
                  this.result = res.status;
                  // if (this.$helpers.handleFeedback(err.status)) {
                  // }
                }
              );
            } else {
              this.result = res.status;
              // this.$helpers.handleFeedback(res.status);
            }
          },
          err => {
            this.feedback.loading = false;
            this.result = err.status;
            // this.$helpers.handleFeedback(err.status);
          }
        );
      } else {
        this.feedback.loading = false;
        this.reset();
        if (!this.$v.username.required) {
          this.feedback.username = this.$t("error.usernameRequired");
        }

        // if (!this.$v.username.alphaNum) {
        //   this.feedback.username = this.$t("error.alphaNumOnly");
        // }

        if (!this.$v.password.required) {
          this.feedback.password = this.$t("error.passwordRequired");
        }
      }

      // reset the error message after 10 s
      this.feedback.timeout = setTimeout(() => {
        this.$v.$reset();
        this.reset();
      }, 10000);
    }
  }
}
</script>